import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Editor } from '@tinymce/tinymce-react';
import { setGlobalVariable } from '../shared';

let globalIntValue = null;

function Support({
  studntIdData,
  StudentName,
  districtName,
  districtID,
  baseUrl,
  categories,
  activeTab,
}) {
  const [isEditorLoading, setIsEditorLoading] = useState(true);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [selectedTeacherEmail, setSelectedTeacherEmail] = useState('');
  const [intValue, setIntValue] = useState(null);
  const editorRef = useRef(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const downArrow = require("../icons/downarrow.png");

  const teacherSet = new Map();
  teacherSet.set("Tango Support", 'support@tangosoftware.com');
  Object.values(categories).forEach((itemList) => {
    itemList.forEach((item) => {
      const teacherName = `${item.FullName}`;
      teacherSet.set(teacherName, item.Email);
    });
  });

  const teachers = Array.from(teacherSet.keys())
    .filter((teacher) => teacher !== "Tango Support")
    .sort((a, b) => a.localeCompare(b))
    .concat("Tango Support");

  //Down arrow
  useEffect(() => {
    const scrollContainer = document.querySelector(".main-content");
    if (!scrollContainer) return;

    const handleScroll = () => {
      const bottom =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 10;
      setShowScrollIndicator(!bottom);
    };

    scrollContainer.addEventListener("scroll", handleScroll);

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(handleScroll);
    });

    resizeObserver.observe(scrollContainer);

    requestAnimationFrame(handleScroll);

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
      'Content-Type': 'application/json', // Optional: Define the content type if needed
    };
    if (token != null) {
      axios
        .get(baseUrl + `Student/GetHelpPageId?studentkey=${studentkey}&districtId=${districtID}&url=${activeTab}`, { headers })
        .then((response) => {
          console.log(response);
          const fetchedValue = response.data;
          setIntValue(fetchedValue);
          setGlobalVariable(fetchedValue);
          console.log('Fetched intValue:', fetchedValue);
        })
        .catch((error) => {
          console.error('Error fetching intValue:', error);
        });
    }
  }, []);

  const handleEditorLoadFailure = () => {
    setIsEditorLoading(false);
    console.error('TinyMCE failed to load. Check the script path or network.');
  };

  const handleSend = () => {
    const htmlMessage = editorRef.current ? editorRef.current.getContent() : '';

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlMessage;
    const plainTextMessage = tempDiv.textContent || '';

    if (!plainTextMessage.trim()) {
      alert('Message cannot be empty!');
      return;
    }

    const DistrictNamewithID = `${districtName} (${districtID})`;
    const StudentNamewithID = `${StudentName} (${studntIdData})`;
    const token = sessionStorage.getItem("authToken");
    const headers = {
      'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
      'Content-Type': 'application/json', // Optional: Define the content type if needed
    };

    const requestData = {
      studentID: DistrictNamewithID,
      studentName: StudentNamewithID,
      emailText: plainTextMessage,
      emailHTML: htmlMessage,
      emailId: selectedTeacherEmail,
    };

    if (token != null) {
      axios
        .post(`${baseUrl}Student/SendEmail`, requestData, { headers })
        .then((response) => {
          console.log('Mail sent successfully:', response.data);
          alert('Mail sent successfully!');
        })
        .catch((error) => {
          console.error('Error sending Mail:', error);
          alert('Failed to send Mail.');
        });
    }
  };

  return (
    <>
      <div>
        {/* <h2>Support</h2> */}
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label htmlFor="studentId" style={{ fontWeight: 'bold' }}>Student ID:</label>
          <input
            type="text"
            id="studentId"
            value={studntIdData}
            readOnly
            style={{ width: '300px', padding: '8px', marginLeft: '35px' }}
          />
        </div>

        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label htmlFor="studentName" style={{ fontWeight: 'bold' }}>Student Name:</label>
          <input
            type="text"
            id="studentName"
            value={StudentName}
            readOnly
            style={{ width: '300px', padding: '8px', marginLeft: '12px' }}
          />
        </div>

        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label htmlFor="teacherDropdown" style={{ fontWeight: 'bold' }}>Addressed To :</label>
          <select
            id="teacherDropdown"
            value={selectedTeacher}
            onChange={(e) => {
              const selectedValue = e.target.value;
              setSelectedTeacher(selectedValue);
              setSelectedTeacherEmail(teacherSet.get(selectedValue));
            }}
            style={{ width: '300px', padding: '8px', marginLeft: '12px' }}
          >
            <option value="" disabled>Select a Value</option>
            {teachers.map((teacher, index) => (
              <option key={index} value={teacher}>
                {teacher}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="editor" style={{ fontWeight: 'bold' }}>Message:</label>
          {isEditorLoading ? (
            <div style={{ textAlign: 'center', marginBottom: '15px' }}>
              <div className="spinner"></div>
              <p>Loading Editor...</p>
            </div>
          ) : null}
          <Editor
            tinymceScriptSrc="/js/vendor/tinymce/tinymce.min.js"
            onInit={(evt, editor) => {
              editorRef.current = editor;
              setIsEditorLoading(false);
            }}
            id="editor"
            init={{
              height: 300,
              menubar: false,
              plugins: [
                'lists link image charmap print preview anchor media table paste code help wordcount',
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat image | help',
            }}
            onError={handleEditorLoadFailure}
          />
        </div>

        <div className="form-group" style={{ marginTop: '15px', float: 'left' }}>
          <button
            onClick={handleSend}
            style={{
              padding: '10px 20px',
              backgroundColor: '#457A23',
              borderRadius: '5px',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Send
          </button>
        </div>
      </div>

      {showScrollIndicator && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            background: "#d0cfcf99",
            color: "white",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "22px",
            zIndex: 9999,
            cursor: "pointer",
            animation: "bounce 1.5s infinite",
          }}
          onClick={() =>
            window.scrollBy({ top: 200, behavior: "smooth" })
          }
        >
          <img
            src={downArrow}
            alt="Scroll down"
            style={{ width: "22px", height: "22px" }}
          />
        </div>
      )}
    </>
  );
}

export { globalIntValue };

export default Support;